function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n\t\ticon-delete\n\t");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "\n\t\tCreated with Sketch.\n\t");

var _ref3 = /*#__PURE__*/React.createElement("defs", null);

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "icon-delete",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.1406435,23.4744687 C10.1406435,24.6232618 11.019547,25.5638994 12.0934072,25.5638994 L19.9065928,25.5638994 C20.980453,25.5638994 21.8593565,24.6232618 21.8593565,23.4744687 L21.8593565,10.9367591 L10.1406435,10.9367591 L10.1406435,23.4744687 Z",
  className: "body",
  fill: "#6F777B",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "lid",
  fill: "#6F777B",
  fillRule: "nonzero",
  points: "22.924694 7.56126523 19.462347 7.56126523 18.4726484 6.43610059 13.5284169 6.43610059 12.537653 7.56126523 9.075306 7.56126523 9.075306 9.8115945 22.924694 9.8115945"
}));

function SvgIconDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default __webpack_public_path__ + "f22e6c6cdb3f0dd8e53ac0aa692888bd.svg";
export { SvgIconDelete as ReactComponent };